import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
export default function ListSkeleton() {
  return (
    <Stack spacing={1}>
      <Skeleton animation="wave" height={50} style={{ marginBottom: 2 }} />
      <Skeleton animation="wave" height={50} style={{ marginBottom: 2, marginLeft: 2 }} />
      <Skeleton animation="wave" height={50} width="80%" />
      <Skeleton variant="wave" width={220} height={50} />
      <Skeleton variant="wave" width={220} height={40} />
      <Skeleton width={220} height={20} />
      <Skeleton width={220} height={60} />
      <Skeleton width={220} height={60} />
      <Skeleton width={220} height={60} />
      <Skeleton width={220} height={60} />
      <Skeleton width={220} height={60} />
      <Skeleton width={220} height={60} />
    </Stack>
  );
}
